/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* FaceValue homepage feature carousel */
(function () {
    const carousel = document.querySelector('[data-fv-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('.fv-home-carousel-track');
    const slides = Array.from(carousel.querySelectorAll('[data-fv-slide]'));
    const controls = Array.from(carousel.querySelectorAll('[data-fv-carousel-control]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let timer = null;
    let touchStartX = null;
    let pointerIsOver = false;
    let focusIsInside = false;

    function stopTimer() {
        window.clearTimeout(timer);
        timer = null;
    }

    function showSlide(nextIndex) {
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach(function (slide, index) {
            const isActive = index === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.tabIndex = isActive ? 0 : -1;
        });

        controls.forEach(function (control, index) {
            const isActive = index === activeIndex;
            control.classList.toggle('is-active', isActive);
            control.setAttribute('aria-pressed', String(isActive));
        });
    }

    function queueNextSlide() {
        stopTimer();
        if (reducedMotion.matches || pointerIsOver || focusIsInside || document.hidden) return;

        timer = window.setTimeout(function () {
            showSlide(activeIndex + 1);
            queueNextSlide();
        }, 5800);
    }

    controls.forEach(function (control) {
        control.addEventListener('click', function () {
            showSlide(Number(control.dataset.fvCarouselControl));
            queueNextSlide();
        });
    });

    carousel.addEventListener('mouseenter', function () {
        pointerIsOver = true;
        stopTimer();
    });

    carousel.addEventListener('mouseleave', function () {
        pointerIsOver = false;
        queueNextSlide();
    });

    carousel.addEventListener('focusin', function () {
        focusIsInside = true;
        stopTimer();
    });

    carousel.addEventListener('focusout', function () {
        window.setTimeout(function () {
            focusIsInside = carousel.contains(document.activeElement);
            queueNextSlide();
        }, 0);
    });

    track.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
        stopTimer();
    }, {passive: true});

    track.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        const distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;

        if (Math.abs(distance) > 50) {
            showSlide(activeIndex + (distance < 0 ? 1 : -1));
        }
        queueNextSlide();
    }, {passive: true});

    document.addEventListener('visibilitychange', queueNextSlide);
    reducedMotion.addEventListener('change', queueNextSlide);
    queueNextSlide();
})();
